export default "__VITE_ASSET__RZRCDtMX__"